import { ShareholderRecord } from '../classes/shared';
import { calculateShareNumbersToBeSold } from './calculateSharesToBeSold';
import { OrgbrainErrorCodes } from '@orgbrain/lib-data';

// Modifies
export function transferAmountFromTo({
  src,
  dst,
  amount,
  eventRef,
  timeStamp,
}: {
  src: ShareholderRecord;
  dst: ShareholderRecord;
  amount: number;
  eventRef: string;
  timeStamp: number;
}): { newSrcRecord: ShareholderRecord; newDstRecord: ShareholderRecord } {
  let newSrcRecord: ShareholderRecord = { ...src };

  let newDstRecord: ShareholderRecord = { ...dst };

  newSrcRecord.amount -= amount;
  newDstRecord.amount += amount;

  if (src && dst && src.numbers && dst.numbers) {
    const { remainingNumbers, soldNumbers } = calculateShareNumbersToBeSold({
      numbers: src.numbers,
      amount,
      eventRef,
      timeStamp,
    });

    newSrcRecord.numbers = remainingNumbers;

    newDstRecord.numbers = newDstRecord?.numbers?.concat(soldNumbers);
  }
  return { newSrcRecord, newDstRecord };
}
export function transferAmountFromShareclassToShareclass({
  deletionRecord,
  addRecord,
  amount,
  eventRef,
  timeStamp,
}: {
  deletionRecord: ShareholderRecord;
  addRecord: ShareholderRecord;
  amount: number;
  eventRef: string;
  timeStamp: number;
}): { newDeletedRecord: ShareholderRecord; newAddRecord: ShareholderRecord } {
  const newDeletedRecord: ShareholderRecord = { ...deletionRecord };

  newDeletedRecord.amount = newDeletedRecord.amount - amount;

  //should never be below 0 in normal cases, probably should throw error
  if (newDeletedRecord.amount < 0) {
    newDeletedRecord.amount = 0;
    throw { code: OrgbrainErrorCodes.BELOW_ZERO };
  }

  const { remainingNumbers } = calculateShareNumbersToBeSold({
    numbers: deletionRecord.numbers,
    amount,
    eventRef,
    timeStamp,
  });

  newDeletedRecord.numbers = remainingNumbers;

  const newAddRecord: ShareholderRecord = { ...addRecord };

  newAddRecord.amount += amount;

  return { newDeletedRecord, newAddRecord };
}
